import { render, staticRenderFns } from "./PatientDetailCalendar.vue?vue&type=template&id=4dd64b7c&scoped=true"
import script from "./PatientDetailCalendar.vue?vue&type=script&lang=js"
export * from "./PatientDetailCalendar.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailCalendar.vue?vue&type=style&index=0&id=4dd64b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd64b7c",
  null
  
)

export default component.exports